import { render, staticRenderFns } from "./amount-flow-statistical-list.vue?vue&type=template&id=56d0caea&scoped=true&"
import script from "./amount-flow-statistical-list.vue?vue&type=script&lang=ts&"
export * from "./amount-flow-statistical-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d0caea",
  null
  
)

export default component.exports